import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TheSearchBar } from '@maropost-ui/liquidsky-ui'
  import { computed, ref } from 'vue'
  import { useRoute } from 'vue-router'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  setup(__props) {

  const showSearchBar = ref<boolean>(true)


  /**
 * ------------------------------------------------------------
 * Key   = Path prefix in the URL (e.g., /accounts, /commerce, /service)
 * Value = Product name string used for search query parameters
 */
const mfeMap: Record<string, string> = {
  accounts: "name",
  commerce: "q",
  service: "name",
}

const route = useRoute()

/**
 * Dynamically compute the search query parameter name
 * ------------------------------------------------------------
 * - Looks at the current browser `window.location.pathname`
 * - Matches the path against our `mfeMap`
 * - Returns the correct product key (e.g., "marketing", "commerce", "service")
 * - Falls back to "name" if no match is found
 *
 */

 const searchQueryParamName = computed<string>(() => {
    const key = Object.keys(mfeMap).find(prefix =>
      route.path.startsWith(`/${prefix}`)
    )
    return key ? mfeMap[key] : "name"
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TheSearchBar), {
    show: showSearchBar.value,
    queryParamName: searchQueryParamName.value
  }, null, 8, ["show", "queryParamName"]))
}
}

})